import React, { Component } from "react";
import { withStyles, styled } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Grid, TextField, Snackbar } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { Table, DatePicker, Button, Input, Select } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { CloseOutlined, DeleteOutlined } from '@ant-design/icons'
import { 
  getCmaList
} from '../../actions/publish'

const { RangePicker } = DatePicker;
const { Option } = Select;


const styles = () => {
  return {
    root: {
      width: "100%",
    },
    search: {
      width: "100%",
      height: "61px",
      padding: "18px 24px",
      flexFlow: "column",
      background: "#fff",
    },
    line: {
      height: "25px",
      fontSize: "14px",
      color: "#000",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    },
    title: {
      marginRight: "10px",
      fontSize: "18px",
      fontWeight: "bold",
      color: "#5F6876",
    },
    btn: {
      width: "70px",
      height: "40px",
      background: "#3276C3",
      borderRadius: "0 !important",
    },
    container: {
      paddingTop: "20px",
    },
    dateFilter: {
      width: "236px",
      padding: "8px",
    },
    defaultFilter: {
      width: "196px",
      padding: "8px",
    },
    btnLine: {
      marginTop: "8px",
      display: 'flex',
      justifyContent: 'space-between'
    },
    select: {
      width: '100%'
    },
    tableContainer: {
      width: '100%',
      '& .ant-table-cell-row-hover': {
        background: '#f0fbff !important'
      },
      '& td.ant-table-column-sort': {
        background: '#f0fbff !important'
      }
    }
  };
};

class Cma extends Component {
  constructor(props){
    super(props);
  }

  state = {
    loading: true,
    filteredInfo: null,
    filterForm: {},
    filterDropdownVisible: false,
    companyArr: [], // 申请人下拉数据
    dataSourceArr: [], // 数据来源下拉数据
    columns: [],
    data: [],
    updateTime: '',
    searchHistoryList: [],
    form: {},
    defaultForm: { // 默认值
      KeyWord: "",
      CMANumber: "",
      EneralCategory: "",
      Category: "",
      ProductOrProjectOrParameter: "",
      StandardName: "",
      StandardNumber: "",
      RoomName: "",
      RoomAddress: "",
    },
    labelObj: {
      KeyWord: '关键词',
      CMANumber: 'CMA编号',
      EneralCategory: '大类',
      Category: '类别',
      ProductOrProjectOrParameter: '产品项目参数',
      StandardName: '标准名称',
      StandardNumber: '标准编号',
      RoomName: '场所名称',
      RoomAddress: '场所地址',
    },
    sortObj: {},
    page: {
      PageNo: 1,
      PageSize: 10
    },
    total: 0,
    paginationObj: {
      showSizeChanger: true,
      allTotal: 0,
      total: 0,
      showTotal: (total, range) => {
        return '当前已筛选出【' + this.state.paginationObj.total + '】条，总数据量【' + this.state.paginationObj.allTotal + '】条'
      },
      onChange: (page, pageSize) => {
        this.pageChange(page, pageSize)
      },
    }
  };

  componentDidMount() {
    let form = {
      ...this.state.defaultForm
    }
    this.setState({
      form,
    })
    let date = new Date()
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    let today = `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`
    this.setState({
      updateTime: today
    })

    let search = decodeURI(this.props.location.search)
    let params = search.substring(1).split('&')
    let obj = params.find(v => {
      return v.indexOf('keyword=') == 0
    })
    if (obj) {
      let urlKeyword = obj.split('=')[1]
      this.setState({
        form: {
          ...this.state.form,
          KeyWord: urlKeyword,
        },
      }, () => this.initData())
    } else {
      this.initData()
    }
  }

  resetForm = () => {
    this.setState({
      form: {
        KeyWord: "",
        CMANumber: "",
        EneralCategory: "",
        Category: "",
        ProductOrProjectOrParameter: "",
        StandardName: "",
        StandardNumber: "",
        RoomName: "",
        RoomAddress: "",
      }
    })
  }

  clearHistory = () => {
    this.resetForm()
    this.setState({
      searchHistoryList: []
    }, () => this.initData())
  }

  removeSearchItem = (data, i) => {
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    form[data.key] = this.state.defaultForm[data.key]
    list.splice(i, 1)
    this.setState({
      form: form,
      searchHistoryList: list
    }, () => this.initData())
  }

  searchForm = () => {
    this.initData()
    // 添加历史搜索记录
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    for (let key in form) {
      let index = list.findIndex(v => {
        return v.key == key
      })
      if (form[key] && form[key].length > 0) {
        let showValue = form[key]
      
        if (index === -1) {
          let param = {
            label: this.state.labelObj[key],
            value: showValue,
            key: key
          } 
          list.push(param)
        } else {
          let itemIndex = list.findIndex(v => {
            return v.key == key
          })
          list[itemIndex].value = showValue
        }
      } else {
        if (index > -1) {
          list.splice(index, 1)
        }
      }
    }
    this.setState({
      searchHistoryList: list
    })
  }

  onChangeForm = (value, key) => {
    let form = {
      ...this.state.form
    }
    form[key] = value
    this.setState({
      form: form
    })
  }

  initData = () => {
    let param =  Object.assign({}, this.state.form, this.state.page)
    this.setState({
      loading: true
    })
    getCmaList(param).then(res => {
      if (!res.Error) {
        let newPaginationObj = this.state.paginationObj
        newPaginationObj.total = res.DataNumber
        newPaginationObj.allTotal = res.UnfilteredAllDataNumber
        this.setState({
          data: res.DataList.map(v => {
            v.CorporateName = v.ApplicantCompanyOrApplicantProcessingCompany
            return v
          }),
          paginationObj: newPaginationObj,
          loading: false
        }, () => {
          this.getColumns()
        })
      } else {
        this.setState({
          loading: false
        })
      }
    })
  }


  getColumns = () => {
    let classes = this.props.classes

    let columns = [
      {
        title: 'CMA编号',
        dataIndex: 'CMANumber',
        key: 'CMANumber',
        width: 90,
      },
      {
        title: '大类',
        dataIndex: 'EneralCategory',
        width: 90,
        key: 'EneralCategory',
      },
      {
        title: '类别',
        dataIndex: 'Category',
        key: 'Category',
        width: 100,
      },
      {
        title: '产品项目参数',
        dataIndex: 'ProductOrProjectOrParameter',
        width: 130,
        key: 'ProductOrProjectOrParameter',
      },
      {
        title: '标准名称',
        dataIndex: 'StandardName',
        key: 'StandardName',
        width: 200,
      },
      {
        title: '标准编号',
        dataIndex: 'StandardNumber',
        width: 120,
        key: 'StandardNumber',
      },
      {
        title: '场所名称',
        dataIndex: 'RoomName',
        width: 200,
        key: 'RoomName',
      },
      {
        title: '场所地址',
        dataIndex: 'RoomAddress',
        key: 'RoomAddress',
        width: 200,
      },
    ]

    this.setState({
      columns: columns,
    })
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState(
      {
        loading: true,
      },
      () => {
        this.getColumns();
        this.initData();
      }
    );
  };

  handleSort = () => {}

  clearFilters = () => {
    this.setState({ filteredInfo: null });
  };

  clearAll = () => {
    this.setState({
      filteredInfo: null,
      page: {
        PageNo: 1,
        PageSize: 10
      },
      form: {},
      loading: true
    }, () => {
      this.getColumns()
      this.initData()
    });
  };


  handleReset = (clearFilters) => {
    clearFilters()
  }

  handleSearch = (key, value, confirm) => {
    let newForm = this.state.form
  
    if (value instanceof Array && value.length > 1) {
      newForm[key] = value.join(';')
    } else {
      newForm[key] = value
    }
    
    this.setState({
      form: newForm,
      loading: true
    }, () => this.initData())
    confirm()
  }

  pageChange = (page, pageSize) => {
    if (page == this.state.page.PageNo && pageSize == this.state.page.PageSize) {
      return
    }
    this.setState({
      page: {
        PageNo: page,
        PageSize: pageSize
      },
      loading: true
    }, () => this.initData())
  }

  render() {
    const classes = this.props.classes;

    return ( 
      <div className="common-page">
        <div className="common-left-search">
          <div className="left-search-title">
            <span className="search-title">关键词搜索</span>
            
          </div>
          <div className="search-form">
            <div className="form-item">
              <div className="form-label">关键词</div>
              <Input  value={this.state.form.KeyWord}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'KeyWord')} 
                placeholder="请输入关键词"/>
            </div>
            <div className="form-item">
              <div className="form-label">CMA编号</div>
              <Input  value={this.state.form.CMANumber}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'CMANumber')} 
                placeholder="请输入CMA编号"/>
            </div>
            <div className="form-item">
              <div className="form-label">大类</div>
              <Input  value={this.state.form.EneralCategory}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'EneralCategory')} 
                placeholder="请输入大类"/>
            </div>
            <div className="form-item">
              <div className="form-label">类别</div>
              <Input  value={this.state.form.Category}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'Category')} 
                placeholder="请输入类别"/>
            </div>
            <div className="form-item">
              <div className="form-label">产品项目参数</div>
              <Input  value={this.state.form.ProductOrProjectOrParameter}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'ProductOrProjectOrParameter')} 
                placeholder="请输入产品项目参数"/>
            </div>
            <div className="form-item">
              <div className="form-label">标准名称</div>
              <Input  value={this.state.form.StandardName} 
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'StandardName')} 
                placeholder="请输入标准名称"/>
            </div>
            <div className="form-item">
              <div className="form-label">标准编号</div>
              <Input  value={this.state.form.StandardNumber}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'StandardNumber')} 
                placeholder="请输入标准编号"/>
            </div>
            <div className="form-item">
              <div className="form-label">场所名称</div>
              <Input  value={this.state.form.RoomName}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'RoomName')} 
                placeholder="请输入场所名称"/>
            </div>
            <div className="form-item">
              <div className="form-label">场所地址</div>
              <Input  value={this.state.form.RoomAddress}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'RoomAddress')} 
                placeholder="请输入场所地址"/>
            </div>
          
          </div>
  
          <div className="search-bottom-btns">
            <Button className="default-btn" onClick={this.resetForm}>重置</Button>
            <Button className="primary-btn" onClick={this.searchForm}>搜索</Button>
          </div>
        </div>

        <div className="common-main">
          <div className="common-main-search">
            <div className="main-title">
              <div className="title-top">
                <div>
                  <span className="page-title">实用链接</span>
                  <span className="page-count">{this.state.paginationObj.total}条</span>
                </div>
                <span >数据更新至：{this.state.updateTime}</span>
              </div>
            </div>
            {
              this.state.searchHistoryList.length > 0 &&
              <div className="search-history">
                {
                  this.state.searchHistoryList.map((item, i) => (
                    <div className="history-item" key={i}>
                      <span>{item.label}：</span>
                      <span className="history-value">{item.value}</span>
                      <CloseOutlined className="clear-icon" onClick={() => this.removeSearchItem(item, i)}/>
                    </div>
                  ))
                }
                <div className="hitstory-btn" onClick={this.clearHistory}>
                  <DeleteOutlined className="btn-icon"/>
                  清空
                </div>
              </div>
            }
          </div>
          <div className="common-main-container">
            <Grid container className={classes.container} id="tableContainer">
              <Table 
                className={classes.tableContainer}
                columns={this.state.columns} 
                loading={this.state.loading} 
                dataSource={this.state.data} 
                onChange={this.handleChange} 
                pagination={this.state.paginationObj}
                bordered
              />
            </Grid>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(withRouter(Cma));
